import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './DeleteProductInstanceDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const DELETE_PRODUCT_INSTANCE_DIALOG = 'DELETE_PRODUCT_INSTANCE_DIALOG';

const DeleteProductInstanceDialog = props => {
    const dialogButtons = [
        <ButtonLight
            key="cancelProductInstance"
            automationName="cancelProductInstance"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={props.onCancelInstanceButtonClick}
        />,
        <ButtonStandard
            key="deleteProductInstance"
            automationName="deleteProductInstance"
            className={css.deleteButton}
            value={formatMessage(Locale.delete)}
            onClick={props.onDeleteInstanceButtonClick}
        />,
    ];

    return (
        <Dialog
            dialogId={DELETE_PRODUCT_INSTANCE_DIALOG}
            header={formatMessage(Locale.deleteProductInstance)}
            buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer
                        className={css.screenMessage}
                        screenKey={DELETE_PRODUCT_INSTANCE_DIALOG}
                    />
                    <Label value={formatMessage(Locale.deleteProductInstanceConfirmation)} />
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(DeleteProductInstanceDialog);
